import React, { useState } from 'react';

const STORAGE_KEY = 'zime_age_verified';

// sessionStorage (not localStorage) so the gate greets the user on every new
// visit, while a refresh within the same session doesn't re-prompt them.
function readVerified() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export default function AgeGate({ children }) {
  const [verified, setVerified] = useState(readVerified);
  const [denied, setDenied] = useState(false);

  if (verified) return children;

  const confirmAdult = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // Storage unavailable (e.g. private mode) — allow for this session only.
    }
    setVerified(true);
  };

  return (
    <div className={`age-gate${denied ? ' age-gate--minor' : ''}`}>
      <div className="age-gate__card">
        <span className="age-gate__badge">18+</span>

        {denied ? (
          <>
            <h1 className="age-gate__title">Access restricted</h1>
            <p className="age-gate__copy">
              Zimetafsiriwa streams films and series intended for adults.
              You must be at least 18 years old to enter.
            </p>
            <button className="auth-btn age-gate__btn age-gate__btn--secondary" onClick={() => setDenied(false)}>
              Go back
            </button>
          </>
        ) : (
          <>
            <h1 className="age-gate__logo">Zimetafsiriwa</h1>
            <h2 className="age-gate__title">Are you 18 or older?</h2>
            <p className="age-gate__copy">
              This platform contains age-restricted films and series. By
              continuing, you confirm that you are at least 18 years old.
            </p>
            <div className="age-gate__actions">
              <button className="auth-btn age-gate__btn" onClick={confirmAdult}>
                Yes, I am 18 or older
              </button>
              <button className="auth-btn age-gate__btn age-gate__btn--secondary" onClick={() => setDenied(true)}>
                No, I am under 18
              </button>
            </div>
            <small className="age-gate__note">
              An adult must supervise anyone under 18 using this service.
            </small>
          </>
        )}
      </div>
    </div>
  );
}
